import {partial} from 'lodash';

const COLORS = {
    reset: '\x1b[0m',
    red: '\x1b[31m',
    yellow: '\x1b[33m',
    green: '\x1b[32m',
    blue: '\x1b[34m',
};

const LOG = function LOG(effect, ...msgs) {
    // eslint-disable-next-line no-console
    console.log.apply(console, [COLORS[effect]].concat(msgs, COLORS.reset));
};

const logger = {
    log: console.log.bind(console), // eslint-disable-line no-console
    info: partial(LOG, 'blue'),
    error: partial(LOG, 'red'),
    warning: partial(LOG, 'yellow'),
    success: partial(LOG, 'green'),
};

export default logger;
